export default __webpack_public_path__ + "static/media/Alona_Matviychuk.afe858cf.jpg";